<main class="error-50x">
    <div class="cables"></div>
    <h1>ups... <span class="sr-only">Wartungsarbeiten</span></h1>
    <div class="ba-content-article ba-bg-semibright">
        <section class="ba-copytext text-center">
            <p id="ups_text1_txt">Aufgrund von Wartungsarbeiten steht diese Webseite aktuell nicht zur Verfügung.</p>
            <p id="ups_text2_txt">Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.</p>
            <a id="ups_retry_lnk" href="javascript:location.reload()" class="ba-link ba-link-primary"
                >Bitte klicken Sie hier, um die Seite neu zu laden.</a
            >
        </section>
    </div>
</main>
